<template>
  <div class="home">

    <gnetHeader v-if="showheader"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    >
    </gnetTabBar>
    <ordini></ordini>
  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
// import apiclient from '@/apiclient.js'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import ordini from '../components/ordini.vue'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    ordini,
  },
  data: function() {
    return {
        showheader: true,
    };
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>

